<template>
  <div class="desc-level" v-html="output" ref="output-element"></div>
</template>

<script>
import config from "@/client/fetcher.js";
import {marked} from "marked";

export default {
  props: {
    desc: Object,
  },
  computed: {
    output() {
      let text = marked.parse(this.desc.text)
      text = this.tableWrap(text)

      if (process.env.NODE_ENV === 'development') {
        // return this.desc.text.replaceAll('/files/content', config.MainHostFiles+'/content')
        return text.replaceAll('/files/content', config.MainHostFiles+'/content')
      }

      // return this.desc.text
      return text
    }
  },
  methods: {
    tableWrap(text) {
      let htmlContent = marked.parse(text);
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, "text/html");

      doc.querySelectorAll("table").forEach((table) => {
        const wrapper = document.createElement("div");
        wrapper.className = "table-container";
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      });

      return doc.body.innerHTML;
    }
  }
};
</script>

<style scoped>
  .desc-level {
    //padding: 20px 20px;
    //line-height: 1.5;
    text-align: justify;
  }
</style>
